import React from 'react';

export function ProfileIcon({ size = 40, color = 'currentColor', style, ...props }) {
  const uniqueId = React.useMemo(() => Math.random().toString(36).slice(2, 10), []);
  const maskId = `profile-mask-${uniqueId}`;
  const clipPathId = `profile-clip-${uniqueId}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <mask id={maskId} fill="white">
        <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" />
      </mask>

      {/* background: keep transparent; only outline follows currentColor */}
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="none"
      />
      <path
        d="M20 40V39C9.50659 39 1 30.4934 1 20H0H-1C-1 31.598 8.40202 41 20 41V40ZM40 20H39C39 30.4934 30.4934 39 20 39V40V41C31.598 41 41 31.598 41 20H40ZM20 0V1C30.4934 1 39 9.50659 39 20H40H41C41 8.40202 31.598 -1 20 -1V0ZM20 0V-1C8.40202 -1 -1 8.40202 -1 20H0H1C1 9.50659 9.50659 1 20 1V0Z"
        fill="currentColor"
        mask={`url(#${maskId})`}
      />

      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M13.1346 23.8216C14.3097 22.2548 16.1539 21.3327 18.1124 21.3327H20.5569V22.666H18.1124C16.5736 22.666 15.1246 23.3905 14.2013 24.6216L14.168 24.666C14.0598 24.8103 14.0013 24.9857 14.0013 25.166C14.0013 25.6263 14.3744 25.9993 14.8346 25.9993H20.668V27.3327H14.8346C13.638 27.3327 12.668 26.3626 12.668 25.166C12.668 24.6972 12.82 24.2411 13.1013 23.866L13.1346 23.8216Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0013 12.666C18.0887 12.666 16.668 14.3836 16.668 16.3327C16.668 18.2817 18.0887 19.9993 20.0013 19.9993C21.9139 19.9993 23.3346 18.2817 23.3346 16.3327C23.3346 14.3836 21.9139 12.666 20.0013 12.666ZM20.0013 13.9993C18.9684 13.9993 18.0013 14.968 18.0013 16.3327C18.0013 17.6973 18.9684 18.666 20.0013 18.666C21.0342 18.666 22.0013 17.6973 22.0013 16.3327C22.0013 14.968 21.0342 13.9993 20.0013 13.9993Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.2436 21.8961C24.8637 21.1449 23.8056 21.1449 23.4257 21.8961L23.0213 22.6957L22.1778 22.848C21.3425 22.9987 21.0802 24.0083 21.6143 24.5816L22.2261 25.2384L22.1003 26.1511C21.9944 26.9193 22.7832 27.6257 23.5732 27.2205L24.3346 26.8299L25.0961 27.2205C25.8861 27.6257 26.6748 26.9193 26.5689 26.1511L26.4431 25.2384L27.055 24.5816C27.5891 24.0083 27.3268 22.9987 26.4915 22.848L25.648 22.6957L25.2436 21.8961ZM24.3346 23.0532L24.1428 23.4325C24.0007 23.7135 23.7348 23.9218 23.4128 23.9799L22.9532 24.0628L23.2959 24.4307C23.5123 24.663 23.6078 24.9793 23.5654 25.2871L23.5003 25.7593L23.8737 25.5678C24.1635 25.4191 24.5058 25.4191 24.7956 25.5678L25.169 25.7593L25.1039 25.2871C25.0615 24.9793 25.157 24.663 25.3733 24.4307L25.716 24.0628L25.2565 23.9799C24.9345 23.9218 24.6686 23.7135 24.5265 23.4325L24.3346 23.0532Z"
          fill="currentColor"
        />
      </g>

      <defs>
        <clipPath id={clipPathId}>
          <rect width="16" height="16" fill="white" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </svg>
  );
}
